//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* eslint no-underscore-dangle: ["error", { "allow": ["_setNameInternal", "_addUserInternal", "_setHiddenInternal"] }] */

(function() {
  angular.module('curalate').service('InfluencersService', [
    '$http',
    '$q',
    '$timeout',
    'ES6ShimService',
    'DateTimeService',
    'PromiseService',
    'TrackingService',
    function(
            $http,
            $q,
            $timeout,
            ES6ShimService,
            DateTimeService,
            PromiseService,
            TrackingService,
        ) {
      const BASE_URL = '/api/influencers';
      const SAVED_LISTS_URL = `${BASE_URL}/saved/lists`;
      let filterDataGetter = function() { return $q.when({}); };
      const InfluencersService = this;
      const listModels = new Map();
      let listModelsArray = [];

      const userListsHelper = function(user, endpoint) {
        const networkUserId = _(user).safeGet('userId');
        if (!networkUserId) {
          return Promise.resolve({});
        }

        return PromiseService.processHttpResponse($http.get(`${BASE_URL}/saved/${endpoint}/${networkUserId}`)).then((result) => {
          return result.items;
        });
      };

      this.listsByUser = function(user) {
        return userListsHelper(user, 'lists-by-user');
      };

      this.listsByBusinessUser = function(user) {
        return userListsHelper(user, 'lists-by-business-user');
      };

      const processUser = function(user) {
        user.savedUserListIds.forEach((savedListId) => {
          InfluencersService.lists.get(savedListId)._addUserInternal(user);
        });

        user.lastUpdated = moment(user.lastUpdated);

        user.savedLists = user.savedUserListIds.map(listId => InfluencersService.lists.get(listId));

        user.sortedTags = _.pairs(
                    _.countBy(
                        _.flatten(
                            user.recentMedia.map(rm => rm.tags), // 1. Get array of array of recent media tags
                        ),                                       // 2. Flatten to array of tags with dupes
                    ),                                           // 3. Produce histogram of tag counts
                )                                                // 4. Convert to [name,frequency] pairs
                .sort((a, b) => b[1] - a[1])                     // 5. Sort the pairs by frequency
                .map(tagPair => `#${tagPair[0]}`);               // 6. Get just the hashtag
      };
      const tryLoadImg = function(media, fullSize) {
        const deferred = $q.defer();
        const i = new Image();
        const url = fullSize ? media.imageUrl : media.thumbnailUrl;

        i.onload = function() {
          deferred.resolve(media);
        };
        i.onerror = function() {
          deferred.reject(media);
        };

        i.src = url;
        return deferred.promise;
      };

      this.setFilterDataGetter = function(getter) {
        filterDataGetter = getter;
      };

      this.search = function(inputs, limit, offset, queryId) {
        let requestPromise;
        const promise = filterDataGetter().then((data) => {
          data.keywords = inputs.keywords || [];
          data.hashtags = inputs.hashtags || [];
          data.usernames = inputs.usernames || [];
          data.phrases = inputs.phrases || [];
          data.internalQueryById = inputs.internalQueryById;

          const isEmpty = data.keywords.length === 0 &&
                        data.hashtags.length === 0 &&
                        data.usernames.length === 0 &&
                        data.phrases.length === 0 &&
                        (!data.trackedHashtags || data.trackedHashtags.length === 0) &&
                        (!data.relatedHashtags || data.relatedHashtags.length === 0) &&
                        !data.internalQueryById;
          if (isEmpty) {
            return $q.when({ isEmpty: true });
          }

          requestPromise = PromiseService.processHttpResponse($http.post(`${BASE_URL}/search`, data, {
            params: {
              limit,
              offset,
              queryId,
            },
          }));
          return requestPromise.then((results) => {
            requestPromise = null;

            TrackingService.recordEvent(
                            TrackingService.CATEGORY_EXPLORE,
                            TrackingService.ACTION_SEARCH,
                            `Influencers:${(results || {}).queryId}`,
                        );
            if (results) { // results is undefined if the promise was aborted.
              let i = 0;
              results.users.forEach((user) => {
                user.resultPosition = offset + i;
                i++;
                processUser(user);
              });
            }
            return results;
          });
        });
                // Make sure we return a promise with an abort, which aborts the request if it is running.
        promise.abort = function() {
          if (requestPromise) {
            requestPromise.abort();
          }
        };
        return promise;
      };

      this.recordSearchAction = function(queryId, targetNetworkUserId, targetUserPosition, actionType, mediaId) {
                // TODO: Add tracking for track/untrack actions
        if (actionType === 'save') {
          TrackingService.recordEvent(TrackingService.CATEGORY_EXPLORE, TrackingService.ACTION_EXPLORE_SAVE_USER);
        } else if (actionType === 'click') {
          TrackingService.recordEvent(TrackingService.CATEGORY_EXPLORE, TrackingService.ACTION_EXPLORE_CLICK_USER);
        } else if (actionType === 'hide') {
          TrackingService.recordEvent(TrackingService.CATEGORY_EXPLORE, TrackingService.ACTION_EXPLORE_HIDE_USER);
        } else if (actionType === 'clickMedia') {
          TrackingService.recordEvent(TrackingService.CATEGORY_EXPLORE, TrackingService.ACTION_EXPLORE_CLICK_MEDIA);
        }

        return PromiseService.processHttpResponse($http.post(`${BASE_URL}/search/record-action`, {
          queryId,
          targetNetworkUserId,
          targetUserPosition,
          targetMediaId: mediaId,
          actionType,
        }));
      };

      this.bulkAdd = function(usernames, listId) {
        return PromiseService.processHttpResponse($http.put(`${SAVED_LISTS_URL}/${listId}/bulk-add`,
          {
            usernames,
          },
        ));
      };

      this.bulkAddStatus = function(listStatusCacheId) {
        return PromiseService.processHttpResponse($http.get(`${SAVED_LISTS_URL}/bulk-add-status/${listStatusCacheId}`));
      };

      this.hideUser = function(user, reasonData) {
        const { userId, isBusiness } = user;
        const route = isBusiness ? 'hide-business-user' : 'hide-user';
        return PromiseService.processHttpResponse($http.put(`${BASE_URL}/saved/${route}/${userId}`, reasonData));
      };

      this.unhideUser = function(user) {
        const { userId, isBusiness } = user;
        const route = isBusiness ? 'hide-business-user' : 'hide-user';
        return PromiseService.processHttpResponse($http.delete(`${BASE_URL}/saved/${route}/${userId}`));
      };

      this.loadFilterData = function() {
        return PromiseService.processHttpResponse($http.get(`${BASE_URL}/filter-data`));
      };

            //
            // Saved lists
            //

      function List(listId) {
        let listName;
        let isHidden = false;
        let totalCount = 0;
        const usersOnList = new Set();
        const outstandingUserSaves = new Set();

        Object.defineProperty(this, 'id', {
          get() { return listId; },
        });

        Object.defineProperty(this, 'name', {
          get() { return listName; },
        });

        Object.defineProperty(this, 'users', {
          get() { return ES6ShimService.setToArray(usersOnList); },
        });

        Object.defineProperty(this, 'totalCount', {
          get() { return totalCount; },
        });

        Object.defineProperty(this, 'hidden', {
          get() { return isHidden; },
        });

        this.delete = function() {
          TrackingService.recordEvent(TrackingService.CATEGORY_EXPLORE, TrackingService.ACTION_EXPLORE_DELETE_SAVED_LIST);
          const thisList = this;
          return PromiseService.processHttpResponse($http.delete(`${SAVED_LISTS_URL}/${listId}`)).then(() => {
            listModels.delete(listId);
            listModelsArray = _(listModelsArray).without(thisList);
          });
        };

        this.addUser = function(user) {
          const { userId, isBusiness, username } = user;
          const thisList = this;

          const urlPath = isBusiness ? 'business-userid' : 'userid';
          const queryParams = isBusiness ? `?businessUsername=${username}` : `?instagramUsername=${username}`;

                    // Set user save action in progress
          outstandingUserSaves.add(userId);
          return PromiseService.processHttpResponse($http.put(`${SAVED_LISTS_URL}/${listId}/${urlPath}/${userId}${queryParams}`)).then(() => {
            usersOnList.add(userId);
            user.savedLists.push(thisList);
            totalCount++;
          }).finally(() => {
                        // Clear outstanding save action
            outstandingUserSaves.delete(userId);
          });
        };

        this.removeUser = function(user) {
          TrackingService.recordEvent(TrackingService.CATEGORY_EXPLORE, TrackingService.ACTION_EXPLORE_REMOVE_SAVED_USER);
          const { userId, isBusiness } = user;
          const thisList = this;
          const urlPath = isBusiness ? 'business-userid' : 'userid';

          return PromiseService.processHttpResponse($http.delete(`${SAVED_LISTS_URL}/${listId}/${urlPath}/${userId}`)).then(() => {
            usersOnList.delete(userId);
            user.savedLists = _(user.savedLists).without(thisList);
            totalCount--;
          });
        };

        this.fetchUsers = function(limit, offset, search) {
          return PromiseService.processHttpResponse($http.get(`${SAVED_LISTS_URL}/${listId}`, {
            params: {
              limit,
              offset,
              search,
            },
          })).then((results) => {
            results.items.forEach(processUser);
            totalCount = results.totalCount;
            return results.items;
          });
        };

        this.hasUser = function(user) {
          return usersOnList.has(user.userId);
        };

        this._setNameInternal = function(newListName) {
          listName = newListName;
        };

        this._addUserInternal = function(user) {
          usersOnList.add(user.userId);
        };

        this._setHiddenInternal = function(hidden) {
          isHidden = hidden;
        };

        this.getCsvDownloadUrl = function() {
          return `${SAVED_LISTS_URL}/${listId}/influencers.csv`;
        };

        this.getCsvDownloadFilename = function() {
          return `${listName}_${DateTimeService.formatUserMoment(new Date(), 'MM-DD-YYYY')}.csv`;
        };
      }

      this.lists = {
        get(listId) {
          listId = listId || 0; // make sure we're only using numbers here.
          let list = listModels.get(listId);
          if (!list) {
            list = new List(listId);
            listModels.set(listId, list);
            listModelsArray.push(list);
          }
          return list;
        },
      };

      Object.defineProperty(this.lists, 'all', {
        get() {
          return listModelsArray.filter(list => !list.hidden);
        },
      });

      Object.defineProperty(this.lists, 'hiddenList', {
        get() {
          return listModelsArray.filter(list => list.hidden)[0];
        },
      });

      const sortSavedLists = function() {
        listModelsArray = listModelsArray.sort((l1, l2) => {
          if ((l1.name || '').toLowerCase() > (l2.name || '').toLowerCase()) {
            return 1;
          }
          return -1;
        });
      };

      this.createSavedList = function(listName) {
        TrackingService.recordEvent(TrackingService.CATEGORY_EXPLORE, TrackingService.ACTION_EXPLORE_CREATE_SAVED_LIST);
        return PromiseService.processHttpResponse($http.post(SAVED_LISTS_URL, {
          listName,
        })).then((res) => {
          const list = InfluencersService.lists.get(res.listId);
          list._setNameInternal(listName);
          list._setHiddenInternal(false);
          sortSavedLists();
          return list;
        });
      };

            // Immediately fetch the list of Save Lists
      this.savedListsAvailable = (function() {
        return PromiseService.processHttpResponse($http.get(SAVED_LISTS_URL)).then((results) => {
          results.items.forEach((listDto) => {
            const list = InfluencersService.lists.get(listDto.listId);
            list._setNameInternal(listDto.listName);
            list._setHiddenInternal(listDto.hidden);
          });

          sortSavedLists();
          return InfluencersService.lists;
        });
      })();

      this.loadUserData = function(user) {
        const networkUserId = _(user).safeGet('userId');
        if (!networkUserId) {
          return Promise.resolve({});
        }

        return this.savedListsAvailable
                    .then(() => PromiseService.processHttpResponse($http.get(`${BASE_URL}/saved/lists-by-business-user/${networkUserId}`)))
                    .then((results) => {
                      user.savedLists = [];
                      results.items.forEach((listDto) => {
                        const list = InfluencersService.lists.get(listDto.listId);
                        list._addUserInternal(user);
                        user.savedLists.push(list);
                      });
                      return user;
                    });
      };

      this.loadUsersMedia = function(users) {
        const loadUserMedia = function(user) {
          const [head, ...rest] = user.recentMedia;
          const promises = (head ? [tryLoadImg(head, true)] : [])
                        .concat(rest.map(tryLoadImg))
                        .map(mediaPromise => mediaPromise.then((media) => {
                          media.loaded = true;
                          return true;
                        }, () =>
                            // Media failed to load
                            $q.resolve(false)));

          return $q.all(promises).then(() => user);
        };

        let curIdx = 0;

        const loadNext = function() {
          const user = users[curIdx++];
          if (user) {
            loadUserMedia(user).then(() => {
              $timeout(loadNext, 100);
            });
          }
        };

                // Return the promise for the first user.
        return loadNext();
      };
    }]);
})();
